export default "__VITE_ASSET__DO$4hXdu__"